import { ArrowRight, MessageCircle, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';
import ServiceGrid from '../components/ServiceGrid';
import TextNowLink from '../components/TextNowLink';
import { CONTACT, SERVICES } from '../data/siteData';
import { SITE_URL, breadcrumbSchema } from '../lib/seoData';

export default function Services() {
  const structuredData = [
    breadcrumbSchema([
      { name: 'Home', path: '/' },
      { name: 'Services', path: '/services' },
    ]),
    {
      '@type': 'ItemList',
      name: 'Jonny’s Towing and roadside assistance services',
      itemListElement: SERVICES.map((service, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: service.title,
        url: `${SITE_URL}/services/${service.slug}`,
      })),
    },
  ];

  return (
    <>
      <Seo
        title="Towing & Roadside Services Richmond BC"
        description="Flatbed towing, local towing, winching, lockouts, jump starts, tire changes, fuel delivery and specialty transport in Richmond and Greater Vancouver, BC."
        canonicalPath="/services"
        structuredData={structuredData}
      />
      <PageHero
        eyebrow="Towing & roadside assistance"
        title="Capable help for the moment your vehicle cannot continue."
        description="Tell us what happened, where the vehicle is and where it needs to go. We will help identify the right service and equipment."
        image="/images/rolls-royce-flatbed.webp"
      >
        <a className="button button--primary" href={CONTACT.phoneHref} data-roka-cta="call_dispatch" data-roka-label="Call dispatch"><Phone size={18} /> Call now</a>
        <TextNowLink className="button button--ghost"><MessageCircle size={18} /> Text Now</TextNowLink>
        <Link className="button button--ghost" to="/contact#service-request" data-roka-cta="request_tow_all_services" data-roka-label="Request towing"><ArrowRight size={18} /> Request service</Link>
      </PageHero>
      <section className="section container">
        <div className="section-heading centered-heading">
          <span className="eyebrow">What we do</span>
          <h2>Roadside services delivered with professional care.</h2>
          <p>Availability, equipment suitability and pricing depend on location, vehicle condition and job complexity. Call for an accurate assessment.</p>
        </div>
        <ServiceGrid />
      </section>
      <section className="section section--dark">
        <div className="container info-cards">
          <article><h3>Before calling</h3><p>Have your location, vehicle year/make/model, current condition and intended destination ready where possible.</p></article>
          <article><h3>Unattended vehicles</h3><p>Some tows can be completed without the owner present when keys and clear authorization are arranged in advance.</p></article>
          <article><h3>Specialty moves</h3><p>Motorcycles, forklifts, low vehicles, classics and unusual equipment are assessed individually to confirm safe handling.</p></article>
        </div>
      </section>
    </>
  );
}
